module.exports = __webpack_public_path__ + "img/dyqh2.39a80d69.jpg";